import { Suspense } from "react";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import ComponentTypeCardContainer from "./ComponentTypeCardContainer";
import ComponentTypeFinderPlugin from "./ComponentTypeFinderPlugin";
import { Finder2 as Finder } from "../../../../../../modules/finder";
import * as UI from "../../../../../../modules/ui-kit";


const Styled = styled.div`
    align-items: flex-end;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
`;

export default function ComponentTypeSelector(props) {
    const { bimClassID, disabled, onChange, value } = props;

    const [Dialog, open, close] = useDialog();

    function onSelect(componentType) {
        onChange(componentType);
        close();
    }

    return (
        <Styled>
            {
                value && (
                    <Suspense fallback={ <UI.Bone height="1.6rem" width="16rem" /> }>
                        <ComponentTypeCardContainer
                            bimClassID={ bimClassID }
                            id={ value }
                        />
                    </Suspense>
                )
            }
            <UI.Button
                $size="large"
                disabled={ disabled }
                onClick={ open }
            >
                { value ? "Change" : "Select" } ComponentType
            </UI.Button>
            {
                value && (
                    <UI.Button
                        $size="large"
                        disabled={ disabled }
                        onClick={ () => onChange(undefined) }
                    >
                        Remove ComponentType
                    </UI.Button>
                )
            }
            <Dialog>
                <Finder placeholder="Search for a Component Type">
                    <ComponentTypeFinderPlugin
                        bimClassID={ bimClassID }
                        onSelect={ onSelect }
                        id={ value }
                    />
                </Finder>
            </Dialog>
        </Styled>
    );
}
